import { createActionGroup, props } from '@ngrx/store';
import { DeviceAssignmentHistoryItemDto } from '@rocksoft/settings-sdk';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DeviceAssignmentHistoryResolverActions = createActionGroup({
  source: 'Device assignment history resolver',
  events: {
    'History requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DeviceAssignmentHistoryApiActions = createActionGroup({
  source: 'Device assignment history API',
  events: {
    'History loaded': props<{ history: DeviceAssignmentHistoryItemDto[]; deviceId: string }>(),
    'History loaded error': props<{ error: ErrorModel }>(),
  },
});
